import { Button, Modal, Typography, message } from 'antd';

import { useDeleteNotesMutation } from '@/services/notes';

interface IProps {
  noteId: string;
  open: boolean;
  onCancel: () => void;
}

const UnmarkConfirmation = (props: IProps) => {
  const [deleteNote, { isLoading }] = useDeleteNotesMutation();

  const handleSubmit = () => {
    deleteNote(props.noteId)
      .then(() => props.onCancel())
      .then(() => message.success('Anotação removida com sucesso!'));
  };

  const footer = [
    <Button key='back' onClick={props.onCancel} disabled={isLoading} size='large'>
      Cancelar
    </Button>,
    <Button key='submit' type='primary' loading={isLoading} onClick={handleSubmit} size='large'>
      Confirmar
    </Button>
  ];

  return (
    <Modal title='Excluir anotação' footer={footer} open={props.open} closable={false} width={420} centered>
      <Typography.Paragraph>Deseja excluir essa anotação?</Typography.Paragraph>
    </Modal>
  );
};

export default UnmarkConfirmation;
